export default "__VITE_ASSET__a438945e__"